import Script from "next/script";
import React, { FC } from "react";

const GallaboxVideo: FC = () => {
    const [Addclassforvideo, setAddclassforvideo] = React.useState<boolean>(false);

    return (
        <>
            <Script src="https://fast.wistia.com/embed/medias/730lmkyzty.jsonp" async />
            <Script src="https://fast.wistia.com/assets/external/E-v1.js" async />
            <div className="max-w-6xl mx-auto py-20 px-4 flex flex-col items-center">
                <h4 className="p-0 m-0 tracking-wider text-base uppercase font-bold text-center text-caribbean-green">Watch video</h4>
                <h3 className="p-0 m-0 text-2xl lg:text-3xl font-medium text-center max-w-screen-md leading-snug tracking-wide text-white mt-2">Learn more about gallabox</h3>
                <div className="track_videoplay wistia_responsive_padding rounded-xl z-1 mt-10 w-full max-w-screen-md relative" style={{ padding: "46.25% 0 0 0" }}>
                    <div className="wistia_responsive_wrapper h-full w-full absolute top-0 left-0">
                        <div className="wistia_embed wistia_async_730lmkyzty videoFoam=true" style={{ height: "100%", position: "relative", width: "100%" }}>
                            <div
                                className={`${Addclassforvideo && "videoopacity"} wistia_swatch`}
                                style={{
                                    height: "100%",
                                    left: "0",
                                    opacity: "0",
                                    overflow: "hidden",
                                    position: "absolute",
                                    top: "0",
                                    transition: "opacity 200ms",
                                    width: "100%",
                                }}
                            >
                                <img
                                    src="https://fast.wistia.com/embed/medias/730lmkyzty/swatch"
                                    style={{ filter: "blur(5px)", height: "100%", objectFit: "contain", width: "100%" }}
                                    alt="Gallabox - Growth Engine for your business"
                                    aria-hidden="true"
                                    onLoad={() => setAddclassforvideo(true)}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <img alt="wave background" className="absolute top-0 left-0 right-0 bottom-0 w-full" src="https://assets.gallabox.com/gb-home/home/wave-bg.webp" />
        </>
    );
};

export default GallaboxVideo;
